import { Divider, HStack, Text } from '@chakra-ui/react';

const HDivider = ({ fontSize = 'xs', fontWeight = '200', minW, ...props }) => {
  return (
    <HStack mb=".3rem" mt=".7rem">
      <Divider />
      <Text fontSize={fontSize} fontWeight={fontWeight} textTransform="uppercase" as="span" minW={minW}>
        {props.children}
      </Text>
      <Divider />
    </HStack>
  );
};

export default HDivider;
